import React, { useState } from 'react';
// import './EditPress.css';

const EditPress = () => {
  const [pressReleases, setPressReleases] = useState([
    {
      img: 'https://i.imgur.com/91Tt67E.jpeg',
      title: 'Shrayati launches new products in this season...',
      date: '30 Jun, 2024',
      readTime: '2 min read',
    },
    {
      img: 'https://i.imgur.com/91Tt67E.jpeg',
      title: 'Shrayati expands its eco-friendly product range...',
      date: '15 Jul, 2024',
      readTime: '3 min read',
    },
    {
      img: 'https://i.imgur.com/91Tt67E.jpeg',
      title: 'Shrayati introduces sustainable packaging...',
      date: '01 Aug, 2024',
      readTime: '5 min read',
    },
  ]);

  const handleInputChange = (index, field, value) => {
    const updatedPressReleases = [...pressReleases];
    updatedPressReleases[index][field] = value;
    setPressReleases(updatedPressReleases);
  };

  const addPressRelease = () => {
    setPressReleases([
      ...pressReleases,
      {
        img: '',
        title: '',
        date: '',
        readTime: '',
      },
    ]);
  };

  const removePressRelease = (index) => {
    setPressReleases(pressReleases.filter((_, i) => i !== index));
  };

  return (
    <div className="edit-about edit-press-container">
      <h2>Edit Press Releases</h2>
      <div className="cards-container">
        {pressReleases.map((release, index) => (
          <div key={index} className="edit-card">
            <h3>Press Release {index + 1}</h3>
 <div className="divvv">
    <div className="image-preview">
      <br />
              <img src={release.img} alt={`Card ${index + 1} Image`} />
              
            </div>
         <div className="cv-cd-ed">

            <div className="form-group">
              <label>Image URL</label>
              <input
                type="text"
                placeholder="Image URL"
                value={release.img}
                onChange={(e) => handleInputChange(index, 'img', e.target.value)}
              />
            </div>

            <div className="form-group">
              <label>Title</label>
              <input
                type="text"
                placeholder="Title"
                value={release.title}
                onChange={(e) => handleInputChange(index, 'title', e.target.value)}
              />
            </div>

            <div className="form-group">
              <label>Date</label>
              <input
                type="date"
                value={release.date}
                onChange={(e) => handleInputChange(index, 'date', e.target.value)}
              />
            </div>

            <div className="form-group">
              <label>Read Time</label>
              <input
                type="text"
                placeholder="Read Time (e.g., 2 min read)"
                value={release.readTime}
                onChange={(e) => handleInputChange(index, 'readTime', e.target.value)}
              />
            </div>

            <div className="button-group">
              <button type="button" onClick={() => removePressRelease(index)} className="remove-release-btn">
                Remove Press Release
              </button>
            </div>
          </div>
          </div>
          </div>
        ))}
      </div>

      <div className="button-group">
        <button type="button" onClick={addPressRelease} className="add-release-btn">
          Add More Press Release
        </button>
      </div>
      <div className="button-group">
        <button type="button" className="save-btn">
          Save Changes
        </button>
      </div>
    </div>
  );
};

export default EditPress;
